import type { TranslationInterface } from '.';

export const LatvianLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Rakstiet ziņojumu...',
  your_issue_has_been_resolved: 'Jūsu problēma ir atrisināta!',
  new_conversation: 'Jauna saruna',
  welcome_screen_title: 'Laipni lūdzam mūsu atbalsta tērzēšanā',
  welcome_screen_description:
    'Mēs esam šeit, lai palīdzētu! Sāciet sarunu, un mēs jums atbildēsim pēc iespējas ātrāk.',
  your_name_placeholder: 'Jūsu vārds',
  your_email_placeholder: 'Jūsu e-pasta adrese',
  start_chat_button: 'Sazināties ar atbalstu',
  start_chat_button_loading: 'Savienošana...',
  i_need_more_help: 'Man vajag vairāk palīdzības',
  this_was_helpful: 'Tas bija noderīgi',
  optional: 'Neobligāts',
  no_conversations_yet: 'Pagaidām nav sarunu',
  back_to_conversations: 'Atpakaļ pie sarunām',
  closed_conversations: 'Slēgtās sarunas',
  csat_title: 'Kāda bija jūsu saruna?',
  csat_submitted_title: 'Jūs novērtējāt sarunu kā',
  csat_feedback_placeholder: 'Pastāstiet mums vairāk... (neobligāti)',
  follow_up_placeholder: 'Turpināt…',
  companion_layout_label: 'Izkārtojums',
  companion_layout_floating: 'Peldošs',
  companion_layout_sidebar: 'Sānjosla',
  companion_layout_fullscreen: 'Pilnekrāns',
  companion_close: 'Aizvērt',
  companion_history: 'Sarunu vēsture',
  companion_expand_chat: 'Izvērst tērzēšanu',
  companion_sidebar_dock_label: 'Piestiprināšana',
  companion_sidebar_side_label: 'Puse',
  companion_sidebar_left: 'Pa kreisi',
  companion_sidebar_right: 'Pa labi',
  companion_resize_chat: 'Mainīt tērzēšanas izmēru',
  scroll_to_bottom: 'Ritināt uz leju',
  thinking: 'Domāju…',
  running: 'Notiek izpilde…',
  steps: 'darbības',
  step_arguments: 'Argumenti',
  step_result: 'Rezultāts',
  attach_files:
    'Pievienot attēlus, video, PDF vai izklājlapas (maksimālais izmērs 25 MB)',
  mark_page_active:
    'Noklikšķiniet uz kaut kā lapā, lai to atzīmētu — Esc, lai atceltu',
  mark_page: 'Atzīmējiet kaut ko lapā, lai par to pajautātu',
  stop_response: 'Apturēt atbildi',
  copy_reply: 'Kopēt atbildi',
  mentions_empty: 'Nav atbilstību',
  copied: 'Nokopēts',
  send_message: 'Sūtīt ziņu',
  upload_failed: 'Augšupielāde neizdevās: {error}',
  remove_attachment: 'Noņemt pielikumu',
  json_no_items: 'Nav vienumu',
  json_no_data: 'Nav datu',
  json_no_chart_data: 'Diagrammai nav datu',
  json_unsupported: 'Nav atbalstīts: {type}',
  json_see_less: 'Rādīt mazāk',
  json_phone_agent: 'Tālruņa aģents',
  json_phone_agent_test: 'Testēt tīmeklī',
  page_context_remove: 'Noņemt lapas kontekstu',
  json_see_more: 'Rādīt vēl {count}',
  queued_label: '{count} Rindā',
  remove_queued_message: 'Noņemt ziņu no rindas',
  send_queued_now: 'Nosūtīt rindā esošās ziņas tūlīt',
  turn_failed_message: 'Radās problēma, un atbilde nepienāca.',
  turn_failed_retry: 'Mēģināt vēlreiz',
  page_mark_hint: 'Noklikšķiniet uz kaut kā, lai to atzīmētu',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Rāmis',
  page_mark_shape_circle: 'Aplis',
  page_mark_shape_arrow: 'Bulta',
  page_mark_shape_bracket: 'Iekava',
  page_mark_shape_underline: 'Pasvītrojums',
  page_mark_shape_highlight: 'Izcēlums',
  page_mark_shape_strike_through: 'Pārsvītrojums',
  page_mark_shape_crossed_off: 'Krustenisks svītrojums',
  page_mark_shape_aria: 'Atzīmes forma: {shape}',
  page_mark_note_placeholder: 'Pievienot piezīmi… (Enter, lai pievienotu)',
  page_mark_attach: 'Pievienot atzīmi',
  page_mark_remove: 'Noņemt {label}',
  page_mark_region: 'Atzīmēts apgabals',
  page_mark_default_message: 'Kas tas ir?',
  file_rejected: 'Faila tips netiek atbalstīts vai fails ir pārāk liels.',
  dictate: 'Diktēt',
  stop_dictation: 'Pārtraukt diktēšanu',
  dictation_mic_blocked: 'Atļaujiet piekļuvi mikrofonam, lai diktētu',
  dictation_unavailable: 'Diktēšana pašlaik nav pieejama',
  questions_back: 'Atpakaļ',
  questions_next: 'Tālāk',
  questions_send: 'Sūtīt',
  questions_type_answer: 'Rakstīšu pats',
  questions_answer_placeholder: 'Ierakstiet savu atbildi…',
  close_conversation_title: 'Aizvērt sarunu',
  close_conversation_description: 'Vai tiešām vēlaties aizvērt šo sarunu?',
  close_conversation_cancel: 'Nē',
  close_conversation_confirm: 'Jā',
  dialog_close: 'Aizvērt',
  zoom_in: 'Pietuvināt',
  zoom_out: 'Attālināt',
  reset_zoom: 'Atiestatīt tālummaiņu',
  support_chat_aria_label: 'Atbalsta tērzēšana',
};
